export enum PaymentType {
  MaybankFPX = 1,
  Cheque = 2,
  Swift = 3,
  BankIn = 4,
  DuitNow = 5,
  Wallet = 6
}
